import type { IconData } from '@stacksjs/iconify-core'

export const flipHorizontalCircle1: IconData = {
  "body": "<g fill=\"none\" stroke-width=\"3\"><path fill=\"#fff\" d=\"M24 3a21 21 0 1 0 0 42a21 21 0 1 0 0-42\"/><path fill=\"#8fbffa\" d=\"M20.914 3.202C22.044 3.036 23 3.955 23 5.096v37.808c0 1.141-.957 2.06-2.086 1.894C10.78 43.304 3 34.562 3 24C3 13.44 10.78 4.696 20.914 3.202\"/><path stroke=\"#2859c5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M20.914 3.202C22.044 3.036 23 3.955 23 5.096v37.808c0 1.141-.957 2.06-2.086 1.894C10.78 43.304 3 34.562 3 24C3 13.44 10.78 4.696 20.914 3.202m21.932 11.51a21.1 21.1 0 0 0-4.18-5.76m6.031 11.465q.302 1.75.304 3.583c.002 1.833-.104 2.419-.304 3.583m-6.03 11.464a21.1 21.1 0 0 0 4.178-5.758M33.794 5.397A20.8 20.8 0 0 0 29 3.577m0 40.847a20.8 20.8 0 0 0 4.793-1.82\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default flipHorizontalCircle1
